module.exports = __webpack_public_path__ + "media/college_scholarships/match-instantly-ba99a078.png";